/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SetFeiertagOverrideRequest } from '../../models/set-feiertag-override-request';

export interface SetFeiertageOverrideForMitarbeiter$Params {
  mitarbeiterId: string;
      body?: SetFeiertagOverrideRequest
}

export function setFeiertageOverrideForMitarbeiter(http: HttpClient, rootUrl: string, params: SetFeiertageOverrideForMitarbeiter$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, setFeiertageOverrideForMitarbeiter.PATH, 'put');
  if (params) {
    rb.path('mitarbeiterId', params.mitarbeiterId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

setFeiertageOverrideForMitarbeiter.PATH = '/v1/mitarbeiter/{mitarbeiterId}/feiertage-overrides';
